export default __webpack_public_path__ + "static/media/mobilePosDevice.ab7ab763.svg";